import triyoAPI from "./triyo";
import { config } from "../../util/axios-config";

export const ValidateGroupEmail = (email, id) => {
  return triyoAPI.get(
    "/groups/ValidateGroupEmail?email=" + email + "&id=" + id,
    config()
  );
};

export const GetAllUsersAPI = () => {
  return triyoAPI.get(`/users/GetAllUsersForGroups`, config());
};

export const GetGroupByIdAsyncAPI = (groupId) => {
  return triyoAPI.get(`/groups/GetGroupByIdAsync?groupId=${groupId}`, config());
};

export const CreateGroupAsyncAPI = (data) => {
  return triyoAPI.post(`/groups/CreateGroupAsync`, data, config("POST"));
};

export const EditGroupAPI = (data) => {
  return triyoAPI.post(`/groups/EditGroup`, data, config("POST"));
};

export const EditGroupAsyncAPI = (data) => {
  return triyoAPI.post(`/groups/EditGroupAsync`, data, config("POST"));
};

export const GroupExistsWithNameAPI = (data) => {
  return triyoAPI.get(`/groups/GetGroupByName?groupName=${data}`, config());
};

export const GetAllGroupsAPI = (data) => {
  return triyoAPI.get(
    `/groups/GetAllGroups?filter=${JSON.stringify(data)}`,
    config("GET")
  );
};
export const GetFiltersAPI = () => {
  return triyoAPI.get(`/groups/GetGroupFilterList`, config());
};

export const DownloadGroupsAPI = () => {
  return triyoAPI.get(`/groups/DownloadGroup`, config("GET"));
};

export const DeleteGroupAPI = (ids) => {
  let data = { deletedIds: ids.join() };
  return triyoAPI.post(`/groups/RemoveGroup`, data, config("POST"));
};